import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { NotCreatedComponent } from './login/responses/not-created/not-created.component';
import { ValidateComponent } from './login/responses/validate/validate.component';
import { InvalidLoginComponent } from './login/responses/invalid-login/invalid-login.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { LayoutModule } from '@angular/cdk/layout';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-US';
import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import { LocaleService } from './shared/services/locale.service';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { LoginEmailComponent } from './login/login-email/login-email.component';


// removes dot at the end of spanish dates
localeEs[5][1] = localeEs[5][1].map(x => x.slice(0, -1));

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localePt, 'pt');

@NgModule({
	declarations: [
		AppComponent,
		HomeComponent,
		LoginComponent,
		NotCreatedComponent,
		ValidateComponent,
		InvalidLoginComponent,
  		LoginEmailComponent
	],
	imports: [
		BrowserModule,
		LayoutModule,
		FormsModule,
		ReactiveFormsModule,
		AppRoutingModule,
		SharedModule.forRoot(),
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  		ServiceWorkerModule.register('ngsw-worker.js', {
		enabled: environment.production,
		// Register the ServiceWorker as soon as the application is stable
		// or after 30 seconds (whichever comes first).
		registrationStrategy: 'registerWhenStable:30000'
  })
	],
	providers: [
		provideAnimationsAsync(),
		{
			provide: LOCALE_ID,
			deps: [LocaleService],
			useFactory: (LocaleService: { locale: string; }) => LocaleService.locale.slice(0,2)
    },
    /**Only Testing HTTP-SERVER */
    //{provide: LocationStrategy, useClass: HashLocationStrategy}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
